// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Wxzr","box":"WorkspacesBox_box__3kBN3","node":"WorkspacesBox_node__3EdXF"};